const BROWSER_ERROR_FILTERS = [
	/undefined(.*)offsetHeight(.*)/i,
	/Unable to preload CSS for(.*)/i,
	/(.*)gCrWeb(.*)/i,
	/^No error$/i,
	/__show__deepen/i,
	/_avast_submit/i,
	/Access is denied/i,
	/anonymous function: captureException/i,
	/Blocked a frame with origin/i,
	/can't redefine non-configurable property "userAgent"/i,
	/change_ua/i,
	/console is not defined/i,
	/cordova/i,
	/DataCloneError/i,
	/Error: AccessDeny/i,
	/event is not defined/i,
	/feedConf/i,
	/ibFindAllVideos/i,
	/myGloFrameList/i,
	/SecurityError/i,
	/MyIPhoneApp/i,
	/snapchat.com/i,
	/vid_mate_check is not defined/i,
	/win\.document\.body/i,
	/window\._sharedData\.entry_data/i,
	/window\.regainData/i,
	/ztePageScrollModule/,
	/Can't find variable: IntersectionObserver/,
	/Can't find variable: msDiscoverChatAvailable/,
	/undefined is not an object \(evaluating 'ceCurrentVideo.currentTime'\)/,
	/We could not retrieve data from the specified Element. Please make(.*)/i,
	/undefined is not an object \(evaluating 'window.messageHandlers.mailbox'\)/i,
	/find variable: gmo/i,
	// CSP violations (report-only or enforced) already flow to the dedicated csp-report log stream
	// via the header's report-uri; the RUM copy is duplication that pollutes Error Tracking.
	/^csp_violation: /i,
];

const RUM_ONLY_ERROR_FILTERS = [
	// Cross-origin scripts reach window.onerror with the message and stack stripped, so there is nothing to act on.
	/^(?:Uncaught ")?Script error\.?"?(?:\n|$)/,

	/^(?:Uncaught ")?ResizeObserver loop (?:completed with undelivered notifications|limit exceeded)/,
	/^intervention: Ignored attempt to cancel a \w+ event with cancelable=false/,
	/^Invalid call to runtime\.sendMessage\(\)\. Tab not found\./,
	/^Error invoking \w+: Java object is gone/,
	/^Zotero Connector: /,

	// Minified errors from the script Chrome on iOS injects into pages.
	/^La\n[\s\S]*\n {2}at Oi @ /,
	/^pa(?:\n|$)/,
	/^undefined is not an object \(evaluating 'a\.[A-Z]'\)\n[^\n]*\n {2}at [^\n]* @ undefined(?:\n|$)/, // also on Sentry's default ignore list

	// Bridges and providers that in-app browsers and wallets inject into pages.
	/SCDynimacBridge/, // Snapchat
	/__firefox__/, // Firefox on iOS, and Brave on iOS, which is built on it
	/window\.ethereum/, // crypto-wallet providers, such as Brave's
	/window\.webkit\.messageHandlers/, // iOS app web views, such as Instagram's

	// CefSharp, a Chromium embedded in Windows apps such as email link scanners.
	/Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
];

const NETWORK_ERROR_FILTERS = [
	/Load failed/i,
	/Failed to fetch/i,
	/NetworkError when attempting to fetch resource./i,
	/^(?:\w*Error: )?cancelled(?:\n|$)/i,
	/The network connection was lost./i,
	/Importing a module script failed./i,
	/error loading dynamically imported module/i,
	/A network error occurred./,
	/网络连接已中断/i, // Chinese: Network connection interrupted
	/ネットワーク接続が切れました/i, // Japanese: Network connection lost
];

const NEXTJS_ROUTING_ERROR_FILTERS = [
	/Abort fetching component for route/i,
	/Loading initial props cancelled/i,
	/Failed to load static props/i,
];

const ALL_ERROR_FILTERS = [...BROWSER_ERROR_FILTERS, ...NETWORK_ERROR_FILTERS, ...NEXTJS_ROUTING_ERROR_FILTERS];

export function shouldFilterError(error: unknown): boolean {
	const errorString = error?.toString() ?? "";
	return ALL_ERROR_FILTERS.some((pattern) => pattern.test(errorString));
}

export function shouldFilterDatadogPayload(payload: unknown): boolean {
	if (!payload || typeof payload !== "object") {
		return false;
	}

	const candidate = payload as {
		message?: unknown;
		error?: { message?: unknown; stack?: unknown };
	};

	const message =
		typeof candidate.error?.message === "string"
			? candidate.error.message
			: typeof candidate.message === "string"
				? candidate.message
				: undefined;

	const stack = typeof candidate.error?.stack === "string" ? candidate.error.stack : "";
	const errorLike = message ? `${message}\n${stack}` : undefined;

	return (
		shouldFilterError(errorLike) ||
		(errorLike !== undefined && RUM_ONLY_ERROR_FILTERS.some((pattern) => pattern.test(errorLike)))
	);
}
